module.exports = __webpack_public_path__ + "static/media/tip-five.44e2e5ea.png";